// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"547":"0122f194","915":"a6b60d4d"}[chunkId] + ".chunk.js";
};